<!-- As a link -->

<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Deixe seu dados que entraremos em contato!</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">


        <form class="form-horizontal" style="display: block; margin: 5px; padding: 5px;" >
          <fieldset>

          <!-- Text input-->

            <label class="col-md-4 control-label" for="name">Nome</label>
            <div class="col-xs-2">
            <input id="name" name="name" type="text" placeholder="Nome" class="form-control input-md" required="" [(value)]="message.SenderName" (change)='message.SenderName=$event.target.value'>

            </div>

            <br>


          <!-- Text input-->

            <label class="col-md-4 control-label" for="email">Seu e-mail</label>
            <div class="col-xs-2">
            <input id="email" name="email" type="text" placeholder="exemplo@gmail.com" class="form-control input-md" required="" [(value)]="message.SenderEmail" (change)='message.SenderEmail=$event.target.value'>

            </div>

            <br>

          <!-- Text input-->

            <label class="col-md-4 control-label" for="telefone">Seu telefone</label>
            <div class="col-xs-2">
            <input id="telefone" name="telefone" type="text" placeholder="(DDD) 0 0000-0000" class="form-control input-md" required="" [(value)]="message.SenderPhone" (change)='message.SenderPhone=$event.target.value'>

            </div>

            <br>


          <!-- Text input-->

            <label class="col-md-4 control-label" for="mensagem">Sua mensagem</label>
            <div class="col-xs-2">
            <input id="mensagem" name="mensagem" type="text" placeholder="Comentários..." class="form-control input-md" [(value)]="message.SenderComment" (change)='message.SenderComment=$event.target.value'>

            </div>

          </fieldset>
          </form>




      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="sendMail()">Enviar</button>
      </div>
    </div>
  </div>
</div>

  <div id="topo" class="navbar" style="background-image: url('./assets/bgvermelho.png'); display: block; margin: auto;">
    <div class="container-fluid p-1">
      <img src="./assets/logo.png" class="img-fluid" style="display: block; margin: auto;"/>
    </div>

  </div>

  <div class="container-fluid p-3">
    <img src="./assets/guialogo.png" class="img-fluid" style="display: block; margin: auto;"/>


    <div style="display:block; margin: auto; ">

      <button type="button" class="btn btn-primary btn-danger" data-toggle="modal" data-target="#exampleModal">
        <span class="glyphicon glyphicon-question-sign"></span> Dúvidas?
      </button>
    </div>

  </div>

  <div class="container p-2 d-block d-sm-none" style="display: block; margin: auto;">
    <div class="d-flex justify-content-center">
      <p>Ir para</p>
    </div>

    <ul class="pagination pagination-sm justify-content-center">
      <li class="page-item">
        <a class="btn btn-danger px-2" href="#fiscal" role="button" style="margin: auto;">Fiscal</a>
      </li>
      <li class="page-item px-1">
        <a class="btn btn-danger px-2" href="#trabalhista" role="button" style="margin: auto;">Trabalhista</a>
      </li>
      <li class="page-item px-1">
        <a class="btn btn-danger px-2" href="#financas" role="button" style="margin: auto;">Finanças</a>
      </li>
      <li class="page-item px-1">
        <a class="btn btn-danger px-2" href="#legal" role="button" style="margin: auto;">Legal</a>
      </li>
      <li class="page-item">
        <a class="btn btn-danger px-2" href="#geral" role="button" style="margin: auto;">Geral</a>
      </li>
    </ul>
  </div>


  <div class="container-fluid p-3">
    <div class="row">
      <div class="col-sm p-2">
        <app-fiscal id="fiscal"></app-fiscal>
        <div class="container p-2 d-block d-sm-none" style="display: block; margin: auto;">
        <a href="#topo">Voltar</a>
        </div>
      </div>
      <div class="col-sm p-2">
        <app-trabalhista id="trabalhista"></app-trabalhista>
        <div class="container p-2 d-block d-sm-none" style="display: block; margin: auto;">
          <a href="#topo">Voltar</a>
          </div>
      </div>
      <div class="col-sm p-2">
        <app-financas id="financas"></app-financas>
        <div class="container p-2 d-block d-sm-none" style="display: block; margin: auto;">
          <a href="#topo">Voltar</a>
          </div>
      </div>
      <div class="col-sm p-2">
        <app-legal id="legal"></app-legal>
        <div class="container p-2 d-block d-sm-none" style="display: block; margin: auto;">
          <a href="#topo">Voltar</a>
          </div>
      </div>
      <div class="col-sm p-2">
        <app-geral id="geral"></app-geral>
        <div class="container p-2 d-block d-sm-none" style="display: block; margin: auto;">
          <a href="#topo">Voltar</a>
          </div>
      </div>
    </div>
  </div>
